import React from 'react'
import Intro from './Sections/Intro/Intro'
import Landing from './Sections/Landing/Landing';

function App() {

  return (
    <Intro>
      {/* <Menu /> */}
      <Landing />
    </Intro>
  );
}

export default App;
